module.exports = __webpack_public_path__ + "img/ff.8f046b05.svg";